import DialogBox from './src/DialogBox'

DialogBox.install = function (Vue) {
    Vue.component(DialogBox.name, DialogBox);
};

export default DialogBox;